// Real, persistent client-side device identifier -- replaces relying on the
// server's own os.networkInterfaces() (a bug: that's the SERVER's network
// card, identical for every user hitting the same process, not the
// client's device at all -- see elakay_models/user.js's now-retired
// getDeviceInfo()/interfaceMac). Generated once per browser and stored in
// localStorage, then sent with every signup/activation/signin/device-
// verification request so the backend can match "this exact browser" by
// simple equality instead of a fuzzy fingerprint.

const DEVICE_STORAGE_KEY = "elakay_device_id";

export const getOrCreateDeviceId = () => {
    if (typeof window === "undefined" || !window.localStorage) return "";

    let deviceId = "";
    try {
        deviceId = window.localStorage.getItem(DEVICE_STORAGE_KEY) || "";
    } catch {
        deviceId = "";
    }

    if (!deviceId) {
        if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
            deviceId = crypto.randomUUID();
        } else {
            // Non-secret local identifier only -- Math.random() here is fine
            // (this is not a security code, see elakay_helpers/verificationCode.js
            // on the server for what actually protects the account).
            deviceId = [
                Date.now().toString(36),
                Math.random().toString(36).slice(2),
                Math.random().toString(36).slice(2)
            ].join("-");
        }

        try {
            window.localStorage.setItem(DEVICE_STORAGE_KEY, deviceId);
        } catch {
            // localStorage unavailable (private mode, quota, etc.) -- the
            // freshly generated id still works for this single request, it
            // just won't persist across reloads.
        }
    }

    return deviceId;
};

export const getDeviceName = () => {
    const userAgent = (typeof navigator !== "undefined" && navigator.userAgent) || "";

    if (/iPhone/i.test(userAgent)) return "iPhone";
    if (/iPad/i.test(userAgent)) return "iPad";
    if (/Android/i.test(userAgent)) return "Android device";
    if (/Macintosh|Mac OS X/i.test(userAgent)) return "Mac";
    if (/Windows/i.test(userAgent)) return "Windows PC";

    return "Web browser";
};
